import { call, put, takeLatest } from "redux-saga/effects";
import { ffpGenerateOtpRefKey, ffpGenerateOtpRefKeySuccess, ffpGenerateOtpRefKeyFailure, ffpSubmitOtpRef, ffpSubmitOtpRefSuccess, ffpSubmitOtpRefFailure, generateFfpResendOtp, generateFfpResendOtpSuccess, generateFfpResendOtpFailure } from "../../slice/checkin/passengerDetails/ffpGenerateOtpSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchOtpRefKey = async ffpData => {
  const FETCH_OTP_REF_KEY = config?.ROP_CHECKIN_SEND_OTP;
  const headers = {
    AccessToken: sessionStorage.getItem("checkintoken"),
    "Content-Type": "application/json",
    "Accept-Language": `${i18n.language}`
  };
  if (ffpData?.id) {
    headers.otpToken = sessionStorage.getItem("otptoken");
  }
  const data = {
    mode: "no-cors",
    headers,
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: true
  };
  const ffpPayloadData = {
    companyCode: ffpData.companyCode,
    cardNumber: ffpData.cardNumber,
    journeyElementId: ffpData.journeyElementId
  };
  if (ffpData?.id) {
    ffpPayloadData.id = ffpData.id;
  }
  const response = await api.post(`${FETCH_OTP_REF_KEY}`, ffpPayloadData, data);
  if (response) {
    sessionStorage.setItem("otptoken", response.headers["otptoken"]);
  }
  return response;
};
function* getGenerateOtpRefKeyData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchOtpRefKey, payload);
    yield put(ffpGenerateOtpRefKeySuccess(response.data));
  } catch (error) {
    yield put(ffpGenerateOtpRefKeyFailure(error));
  }
}
export function* watchGenerateOtpRefKeyData() {
  yield takeLatest(ffpGenerateOtpRefKey.type, getGenerateOtpRefKeyData);
}
const submitOtpRefKey = async otpData => {
  const FETCH_OTP_REF_KEY = config?.ROP_CHECKIN_ADD_FFP;
  const data = {
    mode: "no-cors",
    headers: {
      AccessToken: sessionStorage.getItem("checkintoken"),
      "Content-Type": "application/json",
      otpToken: sessionStorage.getItem("otptoken"),
      "Accept-Language": `${i18n.language}`
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: true
  };
  const response = await api.post(`${FETCH_OTP_REF_KEY}`, otpData, data);
  return response;
};
function* getFfpSubmitOtpData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(submitOtpRefKey, payload);
    yield put(ffpSubmitOtpRefSuccess(response.data));
  } catch (error) {
    yield put(ffpSubmitOtpRefFailure(error));
  }
}
export function* watchFfpSubmitOtp() {
  yield takeLatest(ffpSubmitOtpRef.type, getFfpSubmitOtpData);
}
const resendFfpOtp = async () => {
  const FETCH_OTP_REF_KEY = config?.ROP_CHECKIN_RESEND_OTP;
  const data = {
    mode: "no-cors",
    headers: {
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json",
      AccessToken: sessionStorage.getItem("checkintoken"),
      otpToken: sessionStorage.getItem("otptoken")
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: true
  };
  const requestTime = new Date().toISOString();
  const response = await api.get(`${FETCH_OTP_REF_KEY}?requestTime=${encodeURIComponent(requestTime)}`, data);
  if (response) {
    sessionStorage.setItem("otptoken", response.headers["otptoken"]);
  }
  return response;
};
function* getCheckinResendOtp(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(resendFfpOtp);
    yield put(generateFfpResendOtpSuccess(response.data));
  } catch (error) {
    yield put(generateFfpResendOtpFailure(error));
  }
}
export function* watchGenerateFfpResendOtp() {
  yield takeLatest(generateFfpResendOtp.type, getCheckinResendOtp);
}